import React from 'react';

export default function ConversionFooterFinance({ financeFooterText = '' }) {
    return (
        <p className="text--xs">
            {financeFooterText}
        </p>
    );
}
